// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 536) return "static/chunks/536-28585b499828eede.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 937 ? "78e521c3" : chunkId) + "." + {"367":"825079cbebe7446c","915":"8b46c81baca162fb","937":"0ae5864a957244dc"}[chunkId] + ".js";
};